export const appHead = {"meta":[{"name":"adopt-website-id","content":"3aa311f1-3068-459f-a0ce-794e3ec82fae"},{"name":"viewport","content":"width=device-width, initial-scale=1","charset":"UTF-8","language":"pt-BR"},{"name":"meta:language","content":"pt-BR"},{"name":"description","content":"Sorrifacil é uma clínica odontológica especializada em implantes e ortodontia."},{"name":"keywords","content":"implantes, ortodontia, clínica odontológica, sorrifacil"},{"name":"meta:charset","content":"UTF-8"}],"link":[],"style":[],"script":[{"src":"https://tag.goadopt.io/injector.js?website_code=3aa311f1-3068-459f-a0ce-794e3ec82fae","class":"adopt-injector"},{"src":"https://d335luupugsy2.cloudfront.net/js/loader-scripts/1c04e7a4-b803-4364-9e4a-ffd3fb00d1cd-loader.js","async":true,"type":"text/javascript"}],"noscript":[],"charset":"UTF-8","lang":"pt-BR","viewport":"width=device-width, initial-scale=1"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true